/** Aligns with BE `inv_transfer.transfer_status` / `inv_received.received_status`: 1=Open, 2=Closed, 3=Completed. */
export enum TRANSFER_STATUS {
  Open = 1,
  Closed = 2,
  Completed = 3,
}